import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { getEndpoint } from 'src/app/core/services/functions.service';  

export interface ConceptoComision {
  c_emp: string;
  codigo: string;
  descripcion: string;
  tipo: string;
  estado: string;
  activo: boolean;
}

export interface ApiResponse<T> {
  status: string;
  message: string;
  data: T;
}

@Injectable({
  providedIn: 'root'
})
export class ConceptoComisionService {
  //rivate apiUrl = 'http://127.0.0.1:8000/concepto-comision';
  ENDPOINT = getEndpoint('coms_concepto_comision');
  constructor(private http: HttpClient) { }

  getConceptosAjuste(company : string): Observable<ConceptoComision[]> {
    return this.http.get<any>(`${this.ENDPOINT}/ajustes`, {
      headers: { 'company': company }
    }).pipe(
      map(response => {
        if (response && response.hasOwnProperty('data')) {
          return response.data;
        }
        return Array.isArray(response) ? response : [];
      }),
      catchError(error => {
        throw error;
      })
    );
  }

  getConceptosTipoBonificacion(company: string): Observable<ConceptoComision[]> {
    return this.http.get<ConceptoComision[]>(`${this.ENDPOINT}/tipo-bonificacion`, {
      headers: { 'company': company }
    });
  }

  getAllConceptos(company: string): Observable<ConceptoComision[]> {
    return this.http.get<ConceptoComision[]>(this.ENDPOINT , {
      headers: { 'company': company }
    });
  }

  getActiveConceptos(company: string): Observable<ConceptoComision[]> {
    return this.http.get<ConceptoComision[]>(`${this.ENDPOINT}/activos`, {
      headers: { 'company': company }
    });
  }

  getConcepto(codigo: string, company: string): Observable<ConceptoComision | null> {
    return this.http.get<any>(`${this.ENDPOINT}/${codigo}`, {
      headers: { 'company': company }
    }).pipe(
      map(response => {
        if (response && response.hasOwnProperty('data')) {
          return response.data;
        }
        return response;
      }),
      catchError(error => {
        throw error;
      })
    );
  }

  createConcepto(concepto: ConceptoComision, company: string): Observable<ConceptoComision> {
    return this.http.post<ConceptoComision>(this.ENDPOINT, concepto, {
      headers: { 'company': company }
    });
  }

  updateConcepto(codigo: string, concepto: ConceptoComision, company: string): Observable<ConceptoComision> {
    return this.http.put<ConceptoComision>(`${this.ENDPOINT}/${codigo}`, concepto, {
      headers: { 'company': company }
    });
  }

  deleteConcepto(codigo: string, company: string): Observable<void> {
    return this.http.delete<void>(`${this.ENDPOINT}/${codigo}`, {
      headers: { 'company': company }
    });
  }
}
